// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2VStf","error":"Textarea_error__1wT2j","readonly":"Textarea_readonly__tUTNH","disabled":"Textarea_disabled__38XtW"};